import { render } from "./RegionList.vue?vue&type=template&id=1b54919d"
import script from "./RegionList.vue?vue&type=script&lang=js"
export * from "./RegionList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__